import { render, staticRenderFns } from "./TabLoader.vue?vue&type=template&id=4b33b095&"
import script from "./TabLoader.vue?vue&type=script&lang=js&"
export * from "./TabLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports